import { Routes, Route, Navigate, useLocation, Outlet } from 'react-router-dom'

import PayrollDashboard from './pages/payroll-dashboard/view/PayrollDashboard'
import PayrollHistory from './pages/payroll-history/view/PayrollHistory'
import PayrollHistoryReport from './pages/payroll-history/view/PayrollHistoryReport'
import PayrollEdit from './pages/payroll-run-edit/view/PayrollEdit'
import PayrollSummary from './pages/payroll-summary/view/PayrollSummary'
import Page404NotFound from 'pages/404/view/PageNotFound404'
import RegularPayroll from './pages/payroll-run/view/PayrollRun'
import YearlyReport from './pages/payroll-yearly-report/pages/YearlyReport'

const PayrollRoutes = () => {
  const location = useLocation()
  const state = location.state
  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route index element={<Navigate to="dashboard" />} />
        <Route path="dashboard" element={<PayrollDashboard />} />
        {state && (
          <Route path="regular-payroll" element={<Outlet />}>
            <Route path=":month" element={<RegularPayroll items={state.item} />} />
            <Route path=":month/summary" element={<PayrollSummary time={state} />} />
            <Route
              path="edit"
              element={<PayrollEdit time_id={state.time_id} details={state.details} />}
            />
          </Route>
        )}
        <Route path="payroll-history" element={<PayrollHistory />} />
        <Route path="payroll-history/:id" element={<PayrollHistoryReport timeId={state} />} />
        <Route path="yearly-report" element={<YearlyReport />} />
        <Route path="*" element={<Page404NotFound />} />
      </Routes>
    </>
  )
}

export default PayrollRoutes
